export default __webpack_public_path__ + "static/media/9.73410311.svg";